export const solanaNativeDecimals = 9;
export const solanaFactor = 10 ** solanaNativeDecimals